// 移动端是否展示consloe.log
// 从环境变量中获取 env 信息，prod环境禁用移动端的console
const reactAppEnv = process.env
export const consoleFlag = reactAppEnv && reactAppEnv.REACT_APP_ENV === 'prod' ? false : true
